import {
  REQUEST_DATA,
  RECEIVE_DATA,
  RECEIVE_DATA_ERROR,
  CATEGORY_TOGGLE,
  SELECTED_CATEGORIES_CHANGE,
  RESET_DATA,
  PRINT_MODE,
  DISPLAY_LOADING_WARNING,
  REQUEST_SHORT_URL,
  RECEIVE_SHORT_URL,
} from 'Config/types';

export default function actionTrigger(type, data) {
  return { type, payload: data };
}

export function actionDisplayLoadingWarning() {
  return actionTrigger(DISPLAY_LOADING_WARNING);
}

export function actionRequestData() {
  return actionTrigger(REQUEST_DATA);
}

export function actionReceiveData(data = {}) {
  return actionTrigger(RECEIVE_DATA, data);
}

export function actionReceiveDataError(data = {}) {
  return actionTrigger(RECEIVE_DATA_ERROR, data);
}

export function actionCategoryToggle(category) {
  return actionTrigger(CATEGORY_TOGGLE, { category });
}

export function actionSelectedCategoryChange(selectedCategories) {
  return actionTrigger(SELECTED_CATEGORIES_CHANGE, selectedCategories);
}

export function actionResetData() {
  return actionTrigger(RESET_DATA);
}

export function actionPrintMode() {
  return actionTrigger(PRINT_MODE);
}

export function actionRequestShortLink() {
  return actionTrigger(REQUEST_SHORT_URL);
}

export function actionReceiveShortLink(shortened) {
  return actionTrigger(RECEIVE_SHORT_URL, { shortened });
}



// WEBPACK FOOTER //
// ./app/actions/index.js